export default () => (
  /**
   * Icone de 3 barras uma em cima da outra
   * Responsavel por abrir uma side bar.
   * Encontrado em altos niveis de zoom, onde abre uma side bar
   * com login, contatos e modulos.
   */
  <svg
    width="21"
    height="17"
    viewBox="0 0 21 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9858 0.994263C19.6762 0.994263 20.2358 1.55389 20.2358 2.24426C20.2358 2.93464 19.6762 3.49426 18.9858 3.49426H1.48584C0.79549 3.49426 0.23584 2.93464 0.23584 2.24426C0.23584 1.55389 0.79549 0.994263 1.48584 0.994263H18.9858ZM18.9858 7.74426C19.6762 7.74426 20.2358 8.30388 20.2358 8.99426C20.2358 9.68464 19.6762 10.2443 18.9858 10.2443H1.48584C0.79549 10.2443 0.23584 9.68464 0.23584 8.99426C0.23584 8.30388 0.79549 7.74426 1.48584 7.74426H18.9858ZM18.9858 14.4943C19.6762 14.4943 20.2358 15.0539 20.2358 15.7443C20.2358 16.4346 19.6762 16.9943 18.9858 16.9943H1.48584C0.79549 16.9943 0.23584 16.4346 0.23584 15.7443C0.23584 15.0539 0.79549 14.4943 1.48584 14.4943H18.9858Z"
      fill="#1F2D4D"
    />
  </svg>
);
